import { render, staticRenderFns } from "./RealVideoCompnentRTC.vue?vue&type=template&id=c5259d40&scoped=true"
import script from "./RealVideoCompnentRTC.vue?vue&type=script&lang=js"
export * from "./RealVideoCompnentRTC.vue?vue&type=script&lang=js"
import style0 from "./RealVideoCompnentRTC.vue?vue&type=style&index=0&id=c5259d40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5259d40",
  null
  
)

export default component.exports